export default "__VITE_ASSET__322bac2b__"